import { PRODUCT_TYPE_ENUM } from "./ProductTypeColors";

/**
 * Keywords mapping for automatic product type categorization
 * Key: Keyword (lowercase)
 * Value: Target Product Type from PRODUCT_TYPE_ENUM
 */
const KEYWORD_MAPPING = {
  "plateau": PRODUCT_TYPE_ENUM.PLATEAU_FRUITS_DE_MER,
  "vin": PRODUCT_TYPE_ENUM.INDUSTRIEL,
  "conserve": PRODUCT_TYPE_ENUM.INDUSTRIEL,
  "bocal": PRODUCT_TYPE_ENUM.INDUSTRIEL,
  "maison": PRODUCT_TYPE_ENUM.MAISON,
  "poelee": PRODUCT_TYPE_ENUM.MAISON,
  "soupe": PRODUCT_TYPE_ENUM.INDUSTRIEL,
  "terrine": PRODUCT_TYPE_ENUM.INDUSTRIEL,
  "rillette": PRODUCT_TYPE_ENUM.INDUSTRIEL,
  // todo Review these ones:
  'brochette': PRODUCT_TYPE_ENUM.INDUSTRIEL,
  'sauce': PRODUCT_TYPE_ENUM.INDUSTRIEL,
  'marinee': PRODUCT_TYPE_ENUM.INDUSTRIEL,
  'thaï': PRODUCT_TYPE_ENUM.INDUSTRIEL,
  'romarin/citron': PRODUCT_TYPE_ENUM.INDUSTRIEL,
  'thym/citron': PRODUCT_TYPE_ENUM.INDUSTRIEL,
  "meridionale": PRODUCT_TYPE_ENUM.INDUSTRIEL,
  "andalouse": PRODUCT_TYPE_ENUM.INDUSTRIEL,
  "maitre d'hotel": PRODUCT_TYPE_ENUM.INDUSTRIEL,
  "caviar": PRODUCT_TYPE_ENUM.INDUSTRIEL,
  "oscientre": PRODUCT_TYPE_ENUM.INDUSTRIEL,
  "oscietre": PRODUCT_TYPE_ENUM.INDUSTRIEL,
  "schrencki": PRODUCT_TYPE_ENUM.INDUSTRIEL,
  ["THAÎ".toLowerCase()]: PRODUCT_TYPE_ENUM.INDUSTRIEL,
};

/**
 * Categorizes a product based on keywords found in its text
 * @param {string} text The Excel product name or description
 * @returns {string|null} The matched product type or null if no match
 */
export const categorizeByKeywords = (text) => {
  if (!text) return null;

  const lowerText = text.toLowerCase();

  // Find the first keyword that matches
  const match = Object.entries(KEYWORD_MAPPING).find(([keyword]) =>
    lowerText.includes(keyword)
  );

  return match ? match[1] : null;
};

/**
 * Categorizes a product based on EAN
 * Sometimes the ean is not 13 chars so we should not try to categorize it
 * If EAN exists and does not start with '0', returns NON_MAISON
 * @param {string} ean The EAN code from the Excel row
 * @returns {string|null} PRODUCT_TYPE_ENUM.NON_MAISON or null
 */
export const categorizeByEAN = (ean) => {
  if (!ean) return null;
  if (ean.length !== 13) return null;
  const eanString = String(ean).trim();
  if (eanString.length > 0 && !eanString.startsWith('0')) {
    return PRODUCT_TYPE_ENUM.NON_MAISON;
  }
  return null;
};

/**
 * Categorizes a product based on EAN first, then falls back to NOM keyword matching
 * @param {string} ean The EAN code from the Excel row
 * @param {string} nom The product name from the Excel row
 * @returns {string|null} The matched product type or null if no match
 */
export const categorizeProduct = (ean, nom) => {
  const eanType = categorizeByEAN(ean);
  if (eanType) return eanType;
  return categorizeByKeywords(nom);
};

export const applyCategorization = (item) => {
  const excelEAN = item.excelRow?.EAN || item.excelRow?.ean || '';
  const excelName = item.excelRow?.NOM || item.excelRow?.nom || item.excelRow?.Nom || '';
  const autoType = categorizeProduct(excelEAN, excelName);

  if (autoType && item.chosenResult && item.chosenResult.metadata) {
    return {
      ...item,
      productType: autoType,
      chosenResult: {
        ...item.chosenResult,
        metadata: {
          ...item.chosenResult.metadata,
          productType: autoType
        }
      }
    };
  }

  return item;
};
